import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../../base/services/authentication.service";
import { UserRolesEnum } from "../../pages/auth/userRoles.enum";
import { useFundsStore } from "../../components/Funds/fundsStore";
import { formatAmount } from "../../components/Funds/utils";
import { ReactComponent as FundsIcon } from "../../assets/icons/funds-blue.svg";
import "./FundsBadge.scss";

/**
 * Header pill showing the organization's available balance in dollars. Reads
 * from the shared funds store, so any flow that changes the balance (purchase,
 * refund, campaign send/cancel) updates it without touching the header.
 *
 * Visible to the roles that spend from the balance (Organization, Senior/Project
 * Manager), but only the Organization (billing) role can click through to
 * /balance — that route stays billing-only, so for managers the pill is
 * read-only. Hidden until the first successful fetch so a failed request
 * never shows a bogus 0.
 */
const FundsBadge = () => {
   const funds = useFundsStore((state) => state.funds);
   const fetchFunds = useFundsStore((state) => state.fetchFunds);

   const canViewFunds = useMemo(
      () =>
         AuthService.isAuthorized([
            UserRolesEnum.Organization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager
         ]),
      []
   );

   useEffect(() => {
      if (!canViewFunds) return undefined;
      fetchFunds();
      // Scheduled campaigns spend funds server-side while the tab is idle,
      // so re-pull the balance whenever the user comes back to the app.
      const handleFocus = () => fetchFunds();
      window.addEventListener("focus", handleFocus);
      return () => window.removeEventListener("focus", handleFocus);
   }, [canViewFunds, fetchFunds]);

   if (!canViewFunds || funds === null) return null;

   const label = (
      <>
         <FundsIcon className="funds-badge__icon" />
         <span>{formatAmount(funds)}</span>
      </>
   );

   return (
      <div
         className="funds-badge"
         // onClick={() => navigate("/balance")}
      >
         {label}
      </div>
   );
};

export default React.memo(FundsBadge);
